/**
 * Copyright © Veeam Software Group GmbH.
 */

import { JobStateRepresentation } from '@veeam-vspc/models/web-controllers';

export type EJobStates = JobStateRepresentation;
export const EJobStates = JobStateRepresentation;
